import { GenericBladeDynamicContentInfo, GenericSelectiveInputDropdown } from '../genericBladeTypes';

type MapGenericBladeParsedApiData = {
    dynamicContent: GenericBladeDynamicContentInfo
}

export default ({ dynamicContent }: MapGenericBladeParsedApiData) => {
    const options = Object.entries(dynamicContent).reduce(
        (result, [cmsKey, cmsValue]) => (
            Array.isArray(cmsValue) ? { ...result, ['key']: cmsKey.replace('Options', ''), ['options']: cmsValue?.map(({ key, label, value }) => ({ label: key || label || '', value })) } : { ...result }
        ),
    {} as GenericSelectiveInputDropdown,
    );

    return options;
};
